// extracted by mini-css-extract-plugin
export var dashSVG = "dashText-module--dashSVG--nNSk0";
export var strokeOffset = "dashText-module--stroke-offset--rlZlP";
export var textCopy = "dashText-module--textCopy--9Pzke";